import { render } from "./reportOil.vue?vue&type=template&id=c8eb49de&scoped=true"
import script from "./reportOil.vue?vue&type=script&lang=js"
export * from "./reportOil.vue?vue&type=script&lang=js"

import "./reportOil.vue?vue&type=style&index=0&id=c8eb49de&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8eb49de"]])

export default __exports__